export var Severity;
(function (Severity) {
    Severity["High"] = "HIGH";
    Severity["Medium"] = "MEDIUM";
    Severity["Low"] = "LOW";
})(Severity || (Severity = {}));
